import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, from, of } from 'rxjs';
import { catchError, expand, map, reduce, switchMap } from 'rxjs/operators';
import { loadUserWorkspaces, loadUserWorkspacesFailed, loadUserWorkspacesSuccess, loadWorkspacesMembers, loadWorkspacesMembersFailed, loadWorkspacesMembersSuccess } from "../actions/user-workspaces.actions";
import { WorkspaceService } from "src/app/services/workspace/workspace.service";
import { WorkspaceMembers } from "src/app/models/workspace.model";

@Injectable()
export class UserWorkspacesEffects {
	private actions$ = inject(Actions);
	private workspaceService = inject(WorkspaceService);


	// Load the User Workspaces
	loadUserWorkspace$ = createEffect(() => this.actions$.pipe(
		ofType(loadUserWorkspaces),
		switchMap((action) =>
			from(this.workspaceService.loadUserWorkspaces(action.top ?? 10, action.nextToken)).pipe(
				map(page => page
					? loadUserWorkspacesSuccess({
						workspaces: page.data.items,
						nextToken: page.data.nextToken,
						totalCount: page.data.totalCount,
					})
					: loadUserWorkspacesFailed({ error: undefined as never })
				),
				catchError(error => of(loadUserWorkspacesFailed({ error })))
			)
		)
	));

	// Load the WorkspaceMembers
	loadWorkspacesMembers$ = createEffect(() => this.actions$.pipe(
		ofType(loadWorkspacesMembers),
		switchMap((action) =>
			this.workspaceService.loadWorkspacesMembers(action.workspaceId).pipe(
				expand(resp => resp.data.nextToken ? this.workspaceService.loadWorkspacesMembers(action.workspaceId, 10, resp.data.nextToken) : EMPTY),
				map(resp => resp.data.items ?? []),
				reduce((acc: WorkspaceMembers[], members: WorkspaceMembers[]) => acc.concat(members), [] as WorkspaceMembers[]),
				map(members => loadWorkspacesMembersSuccess({ workspaceId: action.workspaceId, members })),
				catchError(error => of(loadWorkspacesMembersFailed({ workspaceId: action.workspaceId, error })))
			)
		)
	));

}
